import { useAtom } from 'jotai';

import { isBillingMode, selectedBillingModeAtom } from '@/atoms/billing';

/**
 * Hook to manage billing mode selection
 * @returns Object with billing mode state and utilities
 */
export const useBillingMode = () => {
  const [selectedBillingMode, setSelectedBillingMode] = useAtom(
    selectedBillingModeAtom
  );

  /**
   * Set billing mode with validation
   */
  const setBillingMode = (value: string) => {
    if (!isBillingMode(value)) {
      throw new Error(`Unknown billing period: ${value}`);
    }

    setSelectedBillingMode(value);
  };

  return {
    selectedBillingMode,
    setBillingMode,
    isCorrectBillingPeriod: isBillingMode,
  };
};

export default useBillingMode;
